import styled from 'styled-components'
import { progressiveBreakpoints } from '../../constants/theme'

const PlansWrapper = styled.div`
  @media ${progressiveBreakpoints.desktopSmall} {
    display: flex;
    justify-content: space-between;
    margin-bottom: 0.5rem;
  }
`

export { PlansWrapper }
